import React from 'react';
import Text from '@/components/cms/Text';

export interface ProgressBarProps {
  label?: string;
  progressPercent?: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ label, progressPercent }) => {
  return (
    <div className="flex w-full flex-col items-center justify-center"
    data-component={"ProgressBar"}
    >
      <Text element="span" className="text-1 mb-2 font-normal">
        {label}
      </Text>
      <div className="block h-2 w-1/2 rounded-sm border bg-gray-medium">
        <div
          className="h-full bg-black"
          style={{ width: `${progressPercent}%` }}
          aria-live="assertive"
          aria-label={`file upload progress, ${progressPercent} percent`}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;
